import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './list-item.css';
import { Flyout } from '../flyouts';
import MoreButton from '../actions/more-button';
import { ForcedAlignment } from '../popout/popout-helpers';

interface Props extends ForcedAlignment {
  /** URL where the user will be redirected when clicking on the item */
  href?: string;
  /** Adds additional classes to the component. */
  className?: string;
  /** List Item Contents */
  children: any;
  /** Contents of the flyout menu */
  flyoutMenu?: ReactNode;
  /** Override horizontal tooltip positioning */
  flyoutAlignX?: ForcedAlignment['xAlign'];
  /** Override verical tooltip positioning */
  flyoutAlignY?: ForcedAlignment['yAlign'];
  /** When true shows the checkmark of the item */
  showCheck?: boolean;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Deprecated and not exported to be consumed outside of Component library.
 * For ListItem refer to ListItem.tsx
 *
 * @param {Props} props
 */
const ListItem = (props: Props) => {
  const {
    children,
    className,
    flyoutMenu,
    flyoutAlignX,
    flyoutAlignY,
    href,
    'data-testid': dataTestId,
    showCheck = false,
    xAlign,
    yAlign,
    ...rest
  } = props;

  const content = (
    <>
      {React.Children.map(children, (child: React.ReactChild) =>
        React.isValidElement(child) ? React.cloneElement(child, { ...rest }) : child
      )}
    </>
  );

  const elm = {
    className: classNames(
      styles.item,
      className,
      styles.listItem,
      flyoutMenu && styles.moreButton,
      !showCheck && styles.basic
    ),
    href,
    'data-testid': dataTestId,
    ...rest
  };

  const flyout = (
    <>
      {flyoutMenu && (
        <Flyout
          trigger={<MoreButton separator />}
          xAlign={flyoutAlignX}
          yAlign={flyoutAlignY}
          className={styles.flyout}
        >
          {flyoutMenu}
        </Flyout>
      )}
    </>
  );

  return href ? (
    <a {...elm}>
      {content}
      {flyout}
    </a>
  ) : (
    <div {...elm}>
      {content}
      {flyout}
    </div>
  );
};

export default ListItem;
